// extracted by mini-css-extract-plugin
module.exports = {"score-board-item":"three-cards-scoreboard_score-board-item__3cjkU","symbol-size":"three-cards-scoreboard_symbol-size__2pyTf"};